import {
	mdiBellOutline,
	mdiClipboardAccount,
	mdiHome,
	mdiMessage,
	mdiNewspaperVariantMultipleOutline,
	mdiShieldAccountOutline,
	mdiStore,
} from '@mdi/js'

// Array of sections

export default [
	{
		icon: mdiHome,
		title: 'Dashboard',
		to: 'club-dashboard',
	},
	{
		icon: mdiShieldAccountOutline,
		title: 'menu.club.clubs',
		to: 'club-clubs-list',
		module: 'MGCL,clubs',
	},
	{
		icon: mdiStore,
		title: 'menu.club.franchiseModels',
		to: 'club-franchise-models-list',
		module: 'MGCL,franchise-models',
	},
	{
		icon: mdiClipboardAccount,
		title: 'menu.club.contactFranchise',
		to: 'club-contact-franchise-list',
	},
	{
		icon: mdiMessage,
		title: 'menu.messages',
		to: 'club-messages-list',
		module: 'MGCL,messages',
	},
	{
		icon: mdiNewspaperVariantMultipleOutline,
		title: 'Newsletter',
		to: 'club-newsletter-list',
		module: 'MGCL,newsletter',
	},
	{
		icon: mdiBellOutline,
		title: 'notifications.notifications',
		module: 'MGCL,notifications',
		children: [
			{
				title: 'menu.notifications.list',
				to: 'club-notifications-list',
			},
			{
				title: 'menu.notifications.templates',
				to: 'network-notification-templates-list',
			},
		],
	},
]
